/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Blank_AddressInputs */

const en_legal_blank_address = /** @type {(inputs: Legal_Blank_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[registered address: to be added]`)
};

const pl_legal_blank_address = /** @type {(inputs: Legal_Blank_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[adres siedziby: do uzupełnienia]`)
};

/**
* | output |
* | --- |
* | "[registered address: to be added]" |
*
* @param {Legal_Blank_AddressInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_blank_address = /** @type {((inputs?: Legal_Blank_AddressInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Blank_AddressInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_blank_address(inputs)
	return en_legal_blank_address(inputs)
});